const CP_CONFIG = {"api_base_url":"//app.coachpeaking.com","apiUrl":"/api/v1","siteRoot":"","DESCRIZIONE_AUTOMATICA":true,"TURNSTILE_SITE_KEY":"0x4AAAAAAFp7cf5AeOOamrtL","WAHOO_DEBUG":false,"WAHOO_DEBUG_WHITELIST":[142],"SUUNTO_DEBUG":false,"SUUNTO_DEBUG_WHITELIST":[142]};window.CP_CONFIG = CP_CONFIG;export {
   CP_CONFIG as default
};
